import { ColorPicker } from "antd";

import { BaseColorPickerProps } from "@/components_v2/FormFields/ColorPicker/types";
import { Color } from "antd/es/color-picker";

const BaseColorPicker = ({ onChange, ...props }: BaseColorPickerProps) => {
  const handleOnChange = (value: Color) => {
    onChange(value.toHexString());
  };

  return <ColorPicker {...props} onChangeComplete={handleOnChange} />;
};

export default BaseColorPicker;
